import { render, staticRenderFns } from "./xtDialogWebNew.vue?vue&type=template&id=1c15a3d0&scoped=true&"
import script from "./xtDialogWebNew.vue?vue&type=script&lang=js&"
export * from "./xtDialogWebNew.vue?vue&type=script&lang=js&"
import style0 from "./xtDialogWebNew.vue?vue&type=style&index=0&id=1c15a3d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15a3d0",
  null
  
)

export default component.exports